import React, {Component} from "react";
import { IGameResultHistoryProps, IGongBallJituHistoryType } from "@/types/GameHistoryTypes";
import { assetImg } from "@/modules/moduleImporter";

import "./index.scss";
import { isPortrait } from "@/modules/commonMobile";

interface IProps extends Omit<IGameResultHistoryProps, "history"> {
    history: IGongBallJituHistoryType[];
}

export default class M33 extends Component<IProps> {
    render() {
        const { lobbyMobile } = this.props;
		const reversedHistory = this.props.history.slice(0).reverse();
        const historyBlink = this.props.historyBlink;
        
        return (
            <div className="history-container m33">
                {
                    reversedHistory.slice(0,
                        this.props.activeGameCount === 1 ||
                        (!lobbyMobile && isPortrait()) ? 6 : 5
                    ).map((item, historyIdx) =>
                        <div className={historyIdx === 0 && historyBlink ? "sl-roadmap-alternating" : ""}
                            key={"m33_hc_" + historyIdx}>
                            {
                                item.ball.split(",").map((ball, ballIdx) =>
                                    assetImg("gb_history", ball, "m33_hc_" + historyIdx + "_" + ballIdx)
                                )
                            }
                        </div>
                    )
                }
            </div>
        );
    }
}